import { gql } from "@apollo/client";

const SURVEY_DEFINITION_FIELDS = `
  surveyId
  surveyName
  status
  sourcePartner
  partnerConfiguration {
    partnerId
    partnerSurveyId
    partnerSettings
  }
`;

const SURVEY_DEFINITION_RESPONSE = `
  surveyDefinition {
    ${SURVEY_DEFINITION_FIELDS}
  }
  error {
    message
    code
  }
`;

export const toSurveyDefinitionInput = ({
  source,
  surveyName,
  surveyId,
  surveyUrl,
}) => ({
  surveyName,
  sourcePartner: source,
  partnerConfiguration: {
    partnerId: source,
    partnerSurveyId: surveyId,
    partnerSettings: { name: surveyName, url: surveyUrl },
  },
});

export const createSurvey = gql`
  mutation CreateSurveyDefinition($input: SurveyDefinitionCreateInput!) {
    createSurveyDefinition(input: $input) {
      ${SURVEY_DEFINITION_RESPONSE}
    }
  }
`;

export const updateSurvey = gql`
  mutation UpdateSurveyDefinition($id: ID!, $input: SurveyDefinitionUpdateInput!) {
    updateSurveyDefinition(id: $id, input: $input) {
      ${SURVEY_DEFINITION_RESPONSE}
    }
  }
`;

export const deleteSurvey = gql`
  mutation DeleteSurveyDefinition($id: ID!) {
    deleteSurveyDefinition(id: $id)
  }
`;
